<template>
	<div class="main container-fluid">
		<nav class="navbar navbar-expand-lg navbar-dark">
			<div class="container-fluid">
				<span class="navbar-brand">Spotify Album Art Generator</span>
				<ul class="navbar-nav">
				<!-- <div class="controls d-flex gap-1"> -->
					<!-- <b-dropdown id="dropdown-1" text="Custom Dimensions" class="mx-1" menu-class="dropdown-menu-dark">
						<b-dropdown-item @click="setWallpaperSize.bind(this, 21, 9, 5040, 2160)"><font-awesome-icon :icon="['fas', 'desktop']"/> 4k Ultrawide (21:9)</b-dropdown-item>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 21, 9, 3360, 1440)"><font-awesome-icon :icon="['fas', 'desktop']"/> 1440p Ultrawide (21:9)</b-dropdown-item>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 21, 9, 2520, 1080)"><font-awesome-icon :icon="['fas', 'desktop']"/> 1080p Ultrawide (21:9)</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 16, 9, 3840, 2160)"><font-awesome-icon :icon="['fas', 'desktop']"/> 4k (16:9)</b-dropdown-item>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 21, 9, 2560, 1440)"><font-awesome-icon :icon="['fas', 'desktop']"/> 1440p (16:9)</b-dropdown-item>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 21, 9, 1920, 1080)"><font-awesome-icon :icon="['fas', 'desktop']"/> 1080p (16:9)</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 13, 6, 2778, 1284)"><font-awesome-icon :icon="['fas', 'mobile-alt']"/> iPhone X+ (13:6)</b-dropdown-item>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 16, 9, 1920, 1080)"><font-awesome-icon :icon="['fas', 'mobile-alt']"/> iPhone 5-8 (16:9)</b-dropdown-item>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 4, 3, 960, 640)"><font-awesome-icon :icon="['fas', 'mobile-alt']"/> iPhone 1-4 (12:9)</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 4, 3, 2160, 1620)"><font-awesome-icon :icon="['fas', 'tablet-alt']"/> iPad (12:9)</b-dropdown-item>
						<b-dropdown-item @click="setWallpaperSize.bind(this, 16, 10, 2304, 1440)"><font-awesome-icon :icon="['fas', 'tablet-alt']"/> Other (16:10)</b-dropdown-item>
					</b-dropdown> -->
					<!-- <div> -->
						<!-- <input class="form-control wallpaper-dimensions-input mx-1" v-model="width" type="number">
						<input class="form-control wallpaper-dimensions-input mx-1" v-model="height" type="number"> -->
					<!-- </div> -->
					<li class="nav-item">
						<a class="nav-link" href="#" @click="shuffleSavedArt">Shuffle</a>
					</li>
					<li class="nav-item">
						<a id="download-wallpaper" class="nav-link" href="#" @click="downloadImage" download="wallpaper.jpg">Download</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#" data-toggle="modal" v-b-modal.export-modal @click="exportJSON">Export JSON</a>
					</li>
					<!-- <b-button class="btn btn-danger" type="button" data-toggle="modal" @click="deleteSavedData">DELETE SAVED DATA</b-button> -->						
				</ul>
				<!-- </div> -->
				<ul class="navbar-nav">
					<li v-if="isAuthenticated" class="navbar-text text-white">
						<span>{{displayName}}</span>
					</li>
					<li v-if="isAuthenticated" class="nav-item">
						<a class="nav-link" href="#" @click="signOut()">Sign Out</a>
					</li>
					<li v-if="!isAuthenticated" class="nav-item">
						<a class="nav-link" v-if="!isAuthenticated" :href="authUrl">Sign In</a>
					</li>
				</ul>
			</div>
		</nav>
		<div class="home">
			<div id="sidebar" class="mx-2">
				<ul class="collection-nav my-0 p-0">
					<!-- <a href="#" @click="openSearch">Search</a> -->
					<li class="my-2 rounded" :class="loadedCollections === this.ARTIST_COLLECTION ? 'collection-active' : ''">
						<a href="#" class="text-decoration-none p-2 text-white d-inline-block" @click="loadTopArtists">Top Artists</a>
					</li>
					<li class="my-2 rounded" :class="loadedCollections === this.PLAYLIST_COLLECTION ? 'collection-active' : ''">
						<a href="#" class="text-decoration-none p-2 text-white d-inline-block" @click="loadPlaylists">Playlists</a>
					</li>
					<!-- <a href="#" @click="getMyAlbums">Albums</a> -->
				</ul>
				<ul class="collection-list m-0 p-0">
					<li v-for="collection in collectionResults" :key="collection.id"
						class="my-3 collection-item"
						@click="loadCollection(collection)">
						<img :src="collection.getPreviewImageUrl()" width="20" height="20"> {{collection.name}}
					</li>
				</ul>
			</div>
			<div id="content-results" class="mx-2">
				<div class="results-controls mb-2">
					<span class="text-light" v-if="!showSearch">{{resultsTitle}}</span>
					<a class="add-all-results" href="#" @click="addAllAlbums()">+Add All</a>
				</div>
				<input v-if="showSearch" v-model="searchQuery" v-on:keyup.enter.prevent="searchArtists" type="search" class="form-control" placeholder="Search">
				<!-- <div class="search-results mt-3" v-if="searchResults">
					<div v-for="item in searchResults"
						class="card mb-2 me-2"
						@click="loadArtistAlbums(item.href)">
						<img :src="item.imageURL" :width="artPreviewLength" :height="artPreviewLength" class="card-img-top">
						<div class="card-body">
							<span>{{item.name}}</span>
						</div>
					</div>
					<button v-if="searchResults.length > 0" class="btn btn-success" @click="loadNextSearchedArtists">Load More</button>
				</div> -->
				<div class="album-preview" v-if="albumArtResults">
					<div v-for="album in albumArtResults" :key="album.id" class="album-container">
						<img :src="album.getSmallestArtUrl(artPreviewLength)" class="album-art">
						<div @click="saveAlbum(album)" class="saved-album-art-remove-overlay noselect">
							<span class="icon">&plus;</span>
						</div>
					</div>
					<!-- <button v-if="apiNext.searchedAlbums > 0" class="btn btn-success" @click="loadNextArtistAlbums">Load More</button> -->
				</div>
			</div>
			<div id="album-art-pane" class="mx-2" :style="`grid: repeat(${height}, 0fr) / repeat(${width}, 1fr)`">
				<div v-for="(album, i) in wallpaperManager.getAllAlbums()" :key="album.id" class="saved-album-art" @click="removeSavedAlbum(i)">
					<img :src="album.getSmallestArtUrl(167.5)"
						class="saved-album-art-img"
						crossorigin="anonymous">
					<div class="saved-album-art-remove-overlay noselect">
						<span class="icon">&times;</span>
					</div>
				</div>
			</div>
			<b-modal id="export-modal">
				<template #modal-title>
					Wallpaper JSON
				</template>
				<textarea class="w-100" v-model="wallpaperJSON"></textarea>
			</b-modal>
		</div>
	</div>
</template>

<script>
import SpotifyClient from '../spotifyClient'
import SpotifyApiClient from '../spotifyApiClient'
import WallpaperManager from '../albumWallpaperManager'
export default {
	name: 'Home',
	data() {
		return {
			loadedCollections: null,
			areArtistsLoaded: false,
			displayName: null,
			searchQuery: "Pink Floyd",
			searchResults: [],
			showSearch: false,
			resultsTitle: "Results",
			albumArtResults: [],
			albumArtResultsLookup: {},
			authUrl: "",
			artPreviewLength: 100,
			savedAlbumsLength: 75,
			spotifyClient: null,
			savedAlbums: [],
			width: 16,
			height: 9,
			collectionResults: [],
			wallpaperJSON: "",
			apiResultLimit: 50,
			isAuthenticated: false,
			COLLECTION_LENGTH_LIMIT: 500,
			ARTIST_COLLECTION: 'artists',
			PLAYLIST_COLLECTION: 'playlists',
		}
	},
	methods: {
		exportJSON() {
			this.wallpaperJSON = this.wallpaperManager.albumsToJson()
		},
		// openSearch() {
		// 	this.showSearch = true
		// 	this.searchArtists();
		// },
		// searchArtists() {
		// 	this.searchResults = []
		// 	this.spotifyClient.searchArtists(this.searchQuery).then(this.processSearchedArtistsResults);
		// },
		// loadNextSearchedArtists() {
		// 	console.log("loadNextSearchedArtists", this.apiNext.searchedArtists)
		// 	if (this.apiNext.searchedArtists) {
		// 		this.spotifyClient.getByURL(this.apiNext.searchedArtists).then(this.processSearchedArtistsResults)
		// 	}
		// },
		// processSearchedArtistsResults(results) {
		// 	console.log("searchArtists results", results)
		// 	for (let item of results.data.artists.items) {
		// 		this.searchResults.push({
		// 			name: item.name,
		// 			href: item.href,
		// 			imageURL: this.getSmallestImage(item.images, this.artPreviewLength)
		// 		});
		// 	}
		// 	this.apiNext.searchedArtists = results.data.artists.next
		// 	this.albumArtResults.clear()
		// },
		// loadArtistAlbums(href) {
		// 	this.spotifyClient.getByURL(href + "/albums?limit=50").then(this.processArtistAlbums);
		// },
		// loadNextArtistAlbums() {
		// 	console.log("loadNextArtistAlbums", this.apiNext.searchedArtists)
		// 	if (this.apiNext.searchedAlbums) {
		// 		this.spotifyClient.getByURL(this.apiNext.searchedAlbums).then(this.processArtistAlbums)
		// 	}
		// },
		// processArtistAlbums(results) {
		// 	console.log("artistAlbum results", results);
		// 	for (let item of results.data.items) {
		// 		this.albumArtResults.add(this.getSmallestImage(item.images, this.artPreviewLength))
		// 	}
		// 	this.apiNext.searchedAlbums = results.data.next
		// 	this.searchResults = [];
		// },
		// getMyAlbums() {
			// 	this.spotifyClient.getByURL("https://api.spotify.com/v1/me/albums?limit=50").then((results) => {
				// 		console.log("my albums", results)
		// 		for (let item of results.data.items) {
			// 			this.albumArtResults.add(this.getSmallestImage(item.album.images, this.artPreviewLength))
		// 		}
		// 		this.searchResults = [];
		// 	})
		// },
		loadCollection(collection) {
			this.albumArtResults = []
			this.albumArtResultsLookup = {}
			this.showSearch = false
			// console.log(collection)
			this.resultsTitle = collection.name
			this.loadCollectionAlbums(collection.getAlbums.bind(collection))
		},
		loadCollectionAlbums(collectionAlbumGetter) {
			collectionAlbumGetter()
				.then(response => this.processLoadedCollectionAlbums(response))
		},
		processLoadedCollectionAlbums(response) {
			for (let album of response.albums) {
				if (!this.albumArtResultsLookup.hasOwnProperty(album.id)) {
					this.albumArtResultsLookup[album.id] = true
					this.albumArtResults.push(album)
				}
			}
			if (response.albums.length > 0) {
				this.loadCollectionAlbums(response.next)
			}
		},
		loadTopArtists() {
			// console.log("loadTopArtists")
			this.collectionResults = []
			this.loadedCollections = this.ARTIST_COLLECTION;
			return this.getCollection(this.spotifyClient.getTopArtists.bind(this.spotifyClient)).then(this.selectFirstCollection)
		},
		loadPlaylists() {
			this.collectionResults = []
			this.loadedCollections = this.PLAYLIST_COLLECTION;
			return this.getCollection(this.spotifyClient.getPlaylists.bind(this.spotifyClient)).then(this.selectFirstCollection)
		},
		selectFirstCollection() {
			// console.log("selectFirstCollection")
			if (this.collectionResults.length > 0) {
				this.loadCollection(this.collectionResults[0])
			}
		},
		getCollection(collectionGetter) {
			// console.log("getCollection")
			return collectionGetter().then(this.processCollection)
		},
		processCollection(response) {
			// console.log("processCollection")
			this.collectionResults = this.collectionResults.concat(response.collection)
			if (response.collection.length > 0 && this.collectionResults.length < this.COLLECTION_LENGTH_LIMIT) {
				this.getCollection(response.next)
			}
		},
		addAllAlbums() {
			for (let album of this.albumArtResults) {
				this.saveAlbum(album)
			}
		},
		saveAlbum(album) {
			// console.log("saveAlbum", album)
			this.wallpaperManager.add(album)
			this.$forceUpdate()
		},
		removeSavedAlbum(i) {
			this.wallpaperManager.remove(i)
			this.$forceUpdate()
		},
		downloadImage() {
			this.wallpaperManager.downloadImage(this.width, this.height)
		},
		shuffleSavedArt() {
			// console.log("shuffleSavedArt")
			this.wallpaperManager.shuffleArt()
			this.$forceUpdate()
		},
		setWallpaperSize(width, height, resX, resY) {
			this.wallpaperManager.setSize(width, height, resX, resY)
		},
		createSpotifyClient() {
			// console.log("Creating spotify client...")
			let spotifyApiClient = new SpotifyApiClient()
			let spotifyClient = new SpotifyClient(spotifyApiClient)
			spotifyClient.onUnauthenticated = () => {
				// console.log("onUnauthenticated")
			};
			return spotifyClient
		},
		createWallpaperManager(spotifyClient) {
			return new WallpaperManager(spotifyClient)
		},
		authenticate() {
			return new Promise((resolve, reject) => {
				if (this.$route.query.code) {
					// console.log("URL has code: authenticating now...")
					this.spotifyClient.authenticateUser(this.$route.query.code).then(() => {
						this.$router.replace('/');
						this.isAuthenticated = true
						resolve()
					}).catch(error => {
						reject(error)
					});
				}
				else {
					resolve()
				}
			})
		},
		loadUserProfile() {
			this.spotifyClient.getUserProfile().then(response => {
				this.isAuthenticated = true
				this.displayName = response.data.display_name
			})
		},
		signOut() {
			this.spotifyClient.signOut()
			window.location.reload()
		}
	},
	mounted() {
		console.clear()
		this.spotifyClient = this.createSpotifyClient()
		this.wallpaperManager = this.createWallpaperManager(this.spotifyClient)
		// Reference the wallpaper saved albums so that vue can render them properly
		this.savedAlbums = this.wallpaperManager.savedAlbums
		this.authUrl = this.spotifyClient.createAuthUrl().then(authUrl => {
			this.authUrl = authUrl
		});
		this.authenticate()
			.then(this.loadUserProfile)
			.then(this.loadPlaylists)
			.catch(console.error)
	},
}
</script>
